import React, { useState, useEffect, useContext, useRef } from "react"
import { Typography, Stack, Box, IconButton, TextField, CircularProgress, Paper } from "@mui/material"
import SendIcon from "@mui/icons-material/Send"
import UserContext from "../../../context/UserContext"
import useFetch from "../../../hooks/useFetch"
import useMutation from "../../../hooks/useMutation"
import { markMessagesAsRead } from "../../../functions/readMessagesFunctions"

const Chat = ({ currentChat }) => {
  const isFinished = currentChat.status !== "matched"

  const [text, setText] = useState("")
  const [chatMessages, setChatMessages] = useState([])
  const endRef = useRef(null)

  const { userData } = useContext(UserContext)
  const userId = userData.user.id

  const { mutate: sendMutation, loading: sendLoading } = useMutation(`/chat/${currentChat?.chatId}`)

  const { data: chatMessagesRaw, loading: chatMessagesLoading } = useFetch(`/chat/${currentChat?.chatId}`, {
    skip: !currentChat || !currentChat?.chatId,
  })

  const loading = chatMessagesLoading

  useEffect(() => {
    markMessagesAsRead(chatMessages, currentChat?.chatId)
  }, [chatMessages, currentChat?.chatId])

  useEffect(() => {
    if (chatMessagesRaw && !chatMessagesLoading) {
      setChatMessages(JSON.parse(chatMessagesRaw.messages))
    } else {
      setChatMessages([])
    }
  }, [chatMessagesRaw, chatMessagesLoading])

  const handleSend = async () => {
    if (!text.trim()) return

    try {
      const res = await sendMutation({
        senderId: userId,
        text: text,
      })

      if (res.messages) {
        setChatMessages(JSON.parse(res.messages))
      }
    } catch (e) {
      console.log(e.message)
    }
    setText("")
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend()
  }

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [chatMessages])

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}>
      {/* <Box
        sx={{
          p: 1.5,
          borderBottom: "1px solid",
          borderColor: "divider",
          textAlign: "center",
        }}>
        <Typography variant="subtitle1" fontWeight={600}>
          Verkäufer
        </Typography>
      </Box> */}

      {loading && <CircularProgress sx={{ width: "100%", alignSelf: "center", mt: 4 }} size={60} thickness={3} color="primary" />}

      {!loading && !chatMessages.length && (
        <Paper sx={{ m: 2, p: 2, bgcolor: "#eee" }}>
          <Typography variant="body2">
            Hier kannst du mit dem {currentChat.action === "buy" ? "Verkäufer" : "Käufer"} den Preis für das Buch besprechen und ein Treffen zur
            Übergabe des Buches vereinbaren.
            <br />
            <br />
            Falls du Fragen hast oder ein Problem auftreten sollte, kannst du den {currentChat.action === "buy" ? "Kauf" : "Verkauf"} im Tab
            "Aktionen" abbrechen oder dich jederzeit an den Support wenden: support@bookay-buecher.de
          </Typography>
        </Paper>
      )}

      <Stack
        spacing={1}
        sx={{
          flex: 1,
          p: 1.5,
          overflowY: "auto",
        }}>
        {!loading &&
          chatMessages.map((msg, i) => (
            <Box
              key={i}
              sx={{
                alignSelf: msg.SenderId === userId ? "flex-end" : "flex-start",
                bgcolor: msg.SenderId === userId ? "primary.light" : "grey.200",
                color: "text.primary",
                px: 1.5,
                py: 1,
                borderRadius: 2,
                maxWidth: "75%",
                wordBreak: "break-word",
              }}>
              <Typography variant="body2">{msg.Text}</Typography>
            </Box>
          ))}
        <div ref={endRef} />
      </Stack>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1,
          borderTop: "1px solid",
          borderColor: "divider",
        }}>
        {isFinished ? (
          <>
            <Typography variant="caption">
              <i>Der {currentChat.action === "buy" ? "Kauf" : "Verkauf"} ist abgeschlossen</i>
            </Typography>
          </>
        ) : (
          <>
            <TextField
              disabled={loading || sendLoading}
              fullWidth
              size="small"
              placeholder="Schreiben..."
              value={text}
              onChange={(e) => setText(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <IconButton onClick={handleSend}>
              <SendIcon />
            </IconButton>
          </>
        )}
      </Box>
    </Box>
  )
}

export default Chat
